import {
    Create,
    NumberInput,
    SelectInput,
    SimpleForm,
    TextInput,
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PackagePlus } from 'lucide-react';
import { useDataProvider } from 'ra-core';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { UOM_CHOICES } from '../documents/shared/companyConstants';
import { HSNAutocomplete } from '../documents/shared/HSNAutocomplete';

const HSNWatcher = () => {
    const { setValue } = useFormContext();
    const dataProvider = useDataProvider();
    const hsnCode = useWatch({ name: 'hsn_code' });

    useEffect(() => {
        if (hsnCode) {
            dataProvider.getList('hsn_codes', {
                pagination: { page: 1, perPage: 1 },
                sort: { field: 'id', order: 'ASC' },
                filter: { code: hsnCode }
            }).then(({ data }) => {
                if (data && data.length > 0) {
                    const hsnDesc = data[0].description;
                    if (hsnDesc) {
                        setValue('description', hsnDesc, { shouldValidate: true, shouldDirty: true });
                    }
                }
            }).catch(e => console.error("Error fetching HSN code info:", e));
        }
    }, [hsnCode, dataProvider, setValue]);

    return null;
};

export const InventoryCreate = () => (
    <Create>
        <SimpleForm className="max-w-4xl mx-auto space-y-6">
            <HSNWatcher />
            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-muted/50">
                    <div className="flex items-center gap-2">
                        <PackagePlus className="w-5 h-5 text-indigo-500" />
                        <CardTitle className="text-lg font-semibold tracking-tight">New Inventory Item</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                <TextInput source="sku" label="SKU" required className="w-full" />
                <TextInput source="name" label="Item Name" required className="w-full" />
                <TextInput source="category" className="w-full" />
                <HSNAutocomplete source="hsn_code" label="HSN Code" className="w-full" />
                <NumberInput source="min_stock_level" label="Min Stock Level" className="w-full" />
                <NumberInput source="unit_price" label="Unit Price" className="w-full" />
                <SelectInput source="unit" label="UoM" choices={UOM_CHOICES} defaultValue="Nos" className="w-full" />
            </div>
            <TextInput source="description" multiline rows={4} className="w-full" />
                </CardContent>
            </Card>
        </SimpleForm>
    </Create>
);
